import React from "react";
import { Box, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import threadsWordmark from "../../assets/logo/threads-logo-wordmark-black.svg";

/**
 * MagazineIssueHeader
 *
 * Props:
 * @param {object} issue - 매거진 이슈 도큐먼트 [Required]
 * @param {boolean} [isMobile] - 모바일 여부 [Optional]
 */
const MagazineIssueHeader = ({ issue, isMobile = false }) => {
	const { t } = useTranslation();

	const base = String(issue?.issueId || issue?.id || "");
	const year = Number.isFinite(issue?.year)
		? issue.year
		: parseInt(base.split("-")[0] || "0", 10);
	const monthNum = Number.isFinite(issue?.month)
		? issue.month
		: parseInt(base.split("-")[1] || "0", 10);
	const monthText = monthNum
		? t(`common.month.${monthNum}`, `${monthNum}월`)
		: "";
	// 2025-08부터 시작하여 달이 진행될수록 +1 계산
	const issueNo = Number.isFinite(issue?.issueNumber)
		? issue.issueNumber
		: Number.isFinite(issue?.issueNo)
		? issue.issueNo
		: (() => {
			// 기준점: 2025년 8월 = 1호
			const baseYear = 2025;
			const baseMonth = 8;
			const baseIssueNo = 1;
			
			if (year && monthNum) {
				const monthsFromBase = (year - baseYear) * 12 + (monthNum - baseMonth);
				return baseIssueNo + monthsFromBase;
			}
			return baseIssueNo;
		})();

	const rightText =
		monthNum && year
			? t("magazine.issueHeaderRight", "{{issueNo}}호: {{month}} {{year}}년", {
					issueNo,
					month: monthText,
					year,
			  })
			: null;

	return (
		<Box
			sx={{
				width: "100%",
				borderBottom: "4px solid",
				borderColor: "primary.main",
				pb: 2,
				display: "flex",
				alignItems: "center",
				justifyContent: "space-between",
				gap: 2,
			}}
		>
			<Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
				<Typography
					variant={isMobile ? "h6" : "h4"}
					color="primary"
					fontWeight={500}
					sx={{
						fontFamily:
							'-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
						letterSpacing: "-0.02em",
						fontSize: isMobile ? "1.1rem" : undefined,
					}}
				>
					{t("magazine.monthly", "Monthly")}
				</Typography>
				<Box
					component="img"
					src={threadsWordmark}
					alt="Threads"
					sx={{
						mt: "2px",
						height: isMobile ? 20 : 36,
						width: "auto",
					}}
				/>
			</Box>
			{rightText && (
			<Typography
				variant={isMobile ? "body2" : "h6"}
				sx={{
					color: "primary.main",
					fontWeight: 600,
					fontSize: isMobile ? "0.875rem" : undefined,
				}}
			>
				{rightText}
			</Typography>
			)}
		</Box>
	);
};

export default MagazineIssueHeader;
